import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

const q8etron: PartialCarConfiguration = {
	specialOfferUrl: 'https://www.audi.es/es/web/es/modelos/agencia/q8-e-tron.html',
};

const sq8etron: PartialCarConfiguration = {
	specialOfferUrl: 'https://www.audi.es/es/web/es/modelos/agencia/sq8-e-tron.html',
};
const q8sbetron: PartialCarConfiguration = {
	specialOfferUrl: 'https://www.audi.es/es/web/es/modelos/agencia/q8-sportback-e-tron.html',
};
const sq8sbetron: PartialCarConfiguration = {
	specialOfferUrl: 'https://www.audi.es/es/web/es/modelos/agencia/sq8-sportback-e-tron.html',
};

export { q8etron, q8sbetron, sq8etron, sq8sbetron };
